interface AudioInstance {
  ctx: AudioContext;
  dest: MediaStreamAudioDestinationNode;
  pcmNode: AudioWorkletNode; // your existing PCM processor (unchanged)
  stream: MediaStream;
  terminating?: boolean;
}

const instances = new Map<string, AudioInstance>();

export function deleteInstance(deviceId: string) {
  const instance = getInstance(deviceId);
  if (!instance || instance.terminating) return;

  instance.terminating = true;

  const {
    ctx, dest, pcmNode, stream,
  } = instance;

  pcmNode.port.postMessage({ stop: true });
  pcmNode.disconnect();
  dest.disconnect();
  if (ctx.state === 'running') {
    ctx.close();
  }
  stream.getTracks().forEach((t) => t.stop());

  instances.delete(deviceId);
}

export function getInstance(deviceId: string) {
  return instances.get(deviceId);
}

export function setInstance(deviceId: string, audioInstance: AudioInstance) {
  instances.set(deviceId, audioInstance);
}

export function getInstances() { return instances; }
